import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/no_data.png'


const _hoisted_1 = { class: "card_container" }
const _hoisted_2 = { class: "main_text" }

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'noData',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.noData')), 1)
  ]))
}
}

})